import { useState, useEffect } from 'react';
import Select from '@mui/material/Select';
import FormHelperText from '@mui/material/FormHelperText';
import FormGroup from '@mui/material/FormGroup';
import InputLabel from '@mui/material/InputLabel';
import Checkbox from '@mui/material/Checkbox';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import ListItemText from '@mui/material/ListItemText';
import InputAdornment from '@mui/material/InputAdornment';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import FormHelpText from './form-helpText';
import { classNames } from '@repo/ui/src/utils/classNames';

const FormMultiSelect = ({ item, unique, submitted }) => {
  const [value, setValue] = useState([]);
  const [error, setError] = useState(false);
  const validate = (val) => {
    if (item.required && val.length === 0) {
      setError(true);
    } else {
      setError(false);
    }
  };

  useEffect(() => {
    if (submitted) {
      validate(value);
    }
  });

  return (
    <>
      <FormGroup className="tw-py-4">
        <InputLabel className="tw-font-normal tw-text-[#42474a] tra-text-web-body-m">{`${
          item.title
        }${item.required ? ' *' : ''}`}</InputLabel>
        <FormControl fullWidth error={error}>
          <Select
            id={`form-${unique}`}
            name={unique}
            title={unique}
            multiple
            value={value}
            variant="outlined"
            required={item.required}
            onBlur={(e) => validate(e.target.value)}
            onChange={(e) => setValue(e.target.value)}
            inputProps={{
              title: `${item.title}${item.required ? ' *' : ''}`,
            }}
            placeholder="Select At Least One"
            renderValue={(selected) => selected.join(', ')}
            className={classNames(
              'tw-bg-white',
              error ? 'tw-shadow-formError focus:tw-shadow-formError' : 'focus:tw-shadow-form',
            )}
            endAdornment={
              <InputAdornment className="tw-pr-6" position="end">
                {error ? (
                  <CancelIcon color="error" />
                ) : value.length === 0 ? (
                  ''
                ) : (
                  <CheckCircleIcon color="primary" />
                )}
              </InputAdornment>
            }
          >
            {item.enumOptions
              ? item.enumOptions.map((option) => (
                  <MenuItem
                    key={`option-${unique}-${option.optionTitle
                      .toLowerCase()
                      .replace(/[^\w]/gi, '_')}`}
                    value={option.optionTitle}
                  >
                    <Checkbox checked={value.indexOf(option.optionTitle) > -1} />
                    <ListItemText primary={option.optionTitle} />
                  </MenuItem>
                ))
              : null}
          </Select>
        </FormControl>
        <FormHelperText
          className={classNames('tw-mt-1 tw-text-red-400', error ? 'tw-block' : 'tw-hidden')}
        >
          {item.validationMessage}
        </FormHelperText>
        <FormHelpText
          display={!!item.helpText}
          unique={unique}
          content={item.helpText !== undefined ? item.helpText : ''}
        />
      </FormGroup>
    </>
  );
};

export default FormMultiSelect;
